import { ReactNode } from 'react'

import { IconButton } from '@mui/material'
import { Col, Span } from 'components'
import { Controller } from 'react-hook-form'
import { COLORS, MASKS, SPACING } from 'utils'

import { CustomInput, InputStyles, InputLabelCustom } from './styles'

interface InputProps extends InputStyles {
  register?: any
  errors?: any
  label?: string
  control?: any
  formValue?: string
  value?: string
  required?: boolean
  placeholder?: string
  inputIcon?: ReactNode
  onClickIcon?: () => void
  onChange?: () => void
  endAdornment?: React.ReactNode
  type?: string
  mask?: 'cnpj' | 'cpf' | 'cep' | 'phone' | 'cellphone' | 'rg' | string
  name?: string
  disabled?: boolean
  maxLength?: number
  defaultValue?: string
}

export const InputLogin: React.FC<InputProps> = ({
  control,
  label,
  errors,
  required = false,
  placeholder,
  disabled = false,
  type,
  marginTop,
  inputIcon,
  onClickIcon,
  marginBottom,
  marginLeft,
  marginRight,
  mask,
  formValue,
  // maxLength,
  defaultValue,
  ...props
}) => {
  const hasError = errors && errors[formValue]

  const formatLabel = label.charAt(0).toUpperCase() + label.slice(1)

  const handleMask = (e) => MASKS.getMask(mask, e)

  return (
    <Col
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
    >
      <InputLabelCustom hasError={hasError}>{formatLabel}</InputLabelCustom>
      <Controller
        name={formValue}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <CustomInput
            {...props}
            name={formValue}
            disabled={disabled}
            type={type || 'text'}
            marginBottom={hasError && SPACING.spacing5}
            value={value}
            onChange={mask ? handleMask : onChange}
            placeholder={placeholder}
            error={!!error}
            hasError={hasError}
            variant="standard"
            autoComplete="off"
            InputProps={{
              endAdornment: (
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={onClickIcon}
                  style={{ margin: 0, padding: 0 }}
                >
                  {inputIcon}
                </IconButton>
              )
            }}
          />
        )}
        rules={{ required }}
      />
      {hasError && (
        <Span
          text={errors[formValue]?.message || 'Erro.'}
          color={COLORS.error}
        />
      )}
    </Col>
  )
}
